import driver from "./driver"

export const comment = `
  id
  createdAt
  text
  tags {
    type
    data {
      id
      note
      sentiment
    }
  }
  driver: driverV2 {
    ${driver}
  }
`
export default comment
